"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppBannerLayout = void 0;
var _react = _interopRequireDefault(require("react"));
var _Container = require("./Container.js");
/**
 * AppBannerLayout will restore the content padding inside an AppBanner and should only be used within AppBanner.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-app-appbannerlayout--docs) |
 * [Encore site](https://encore.spotify.net/web/components/app-layout#appbanner) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/AppBannerLayout)
 */
var AppBannerLayout = exports.AppBannerLayout = /*#__PURE__*/_react["default"].forwardRef(function AppBannerLayout(props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_Container.Container, Object.assign({
    ref: ref
  }, props));
});